<template>
  <div class="home" ref="menu">
    <div class="position-relative header-wrapper">
      <img src="../assets/brandOverseas/bg1.png" alt="">
      <Header></Header>
      <div class="title-content">
        <div class="big-title animate__animated animate__fadeInDown">{{$t('brandOverseas.title1')}}</div>
        <div class="small-title animate__animated animate__fadeInUp">{{$t('brandOverseas.desc1')}}</div>
      </div>
    </div>
    <div class="serve-wrapper">
      <div class="serve-content">
        <div class="top-content">
          <div class="top-title animate__animated animate__fadeInDown">{{$t('brandOverseas.title2')}} </div>
          <div class="desc animate__animated animate__fadeInUp">{{$t('brandOverseas.desc2_1')}}</div>
          <div class="desc animate__animated animate__fadeInUp">{{$t('brandOverseas.desc2_2')}}</div>
        </div>
        <div class="img-wrapper animate__animated">
          <div class="imgs">
            <img src="../assets/brandOverseas/1.png" />
            <div class="tt">{{$t('brandOverseas.serveLine.title1')}}</div>
            <div class="line"></div>
          </div>
          <div class="imgs">
            <img src="../assets/brandOverseas/2.png" />
            <div class="tt">{{$t('brandOverseas.serveLine.title2')}}</div>
            <div class="line"></div>
          </div>
          <div class="imgs">
            <img src="../assets/brandOverseas/3.png" />
            <div class="tt">{{$t('brandOverseas.serveLine.title3')}}</div>
            <div class="line"></div>
          </div>
          <div class="imgs">
            <img src="../assets/brandOverseas/4.png" />
            <div class="tt">{{$t('brandOverseas.serveLine.title4')}}</div>
          </div>
          <div class="imgs">
            <img src="../assets/brandOverseas/5.png" />
            <div class="tt">{{$t('brandOverseas.serveLine.title5')}}</div>
            <div class="line"></div>
          </div>
          <div class="imgs">
            <img src="../assets/brandOverseas/6.png" />
            <div class="tt">{{$t('brandOverseas.serveLine.title6')}}</div>
            <div class="line"></div>
          </div>
          <div class="imgs">
            <img src="../assets/brandOverseas/7.png" />
            <div class="tt">{{$t('brandOverseas.serveLine.title7')}}</div>
            <div class="line"></div>
          </div>
          <div class="imgs">
            <img src="../assets/brandOverseas/8.png" />
            <div class="tt">{{$t('brandOverseas.serveLine.title8')}}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="whatsapp-wrapper">
      <div class="whatsapp-left animate__animated">
        <div class="text_1"><span style="color: #f67618">30{{$t('brandOverseas.whatsapp.title1')}}</span><span>{{$t('brandOverseas.whatsapp.title2')}}</span></div>
        <div class="text_2"><span>{{$t('brandOverseas.whatsapp.title3')}}</span><span style="color: #f67618">121%</span></div>
        <div class="text_3">{{$t('brandOverseas.whatsapp.title4')}}</div>
        <div class="grid-wrap">
          <div class="item">
            <div>650+</div>
            <div>TikTok Influencers</div>
          </div>
          <div class="item">
            <div>206+</div>
            <div>{{$t('brandOverseas.whatsapp.title5')}}</div>
          </div>
          <div class="item">
            <div>1024+</div>
            <div>Lemon8 Influencers</div>
          </div>
          <div class="item">
            <div>302+</div>
            <div>Instagram Influencers</div>
          </div>
        </div>
        <div class="text_4">{{$t('brandOverseas.whatsapp.title6')}}</div>
      </div>
      <div class="whatsapp-right">
        <div class="box1 box animate__animated">
          <img src="../assets/brandOverseas/a1.png" />
          <img src="../assets/brandOverseas/a2.png" />
          <img src="../assets/brandOverseas/a3.png" />
        </div>
        <div class="box2 box animate__animated">
          <img src="../assets/brandOverseas/a4.png" />
          <img src="../assets/brandOverseas/a5.png" />
          <img src="../assets/brandOverseas/a6.png" />
        </div>
        <div class="box3 box animate__animated">
          <img src="../assets/brandOverseas/a7.png" />
          <img src="../assets/brandOverseas/a8.png" />
          <img src="../assets/brandOverseas/a9.png" />
        </div>
      </div>
    </div>
    <div class="data-wrappper">
      <div class="top-text animate__animated">
        <span>{{$t('brandOverseas.caseData.title1')}}</span>
      </div>
      <div class="data-Left animate__animated">
        <div id="pieLeft" class="pie"></div>
        <div class="flex">
          <span class="cube" style="background: #ff6082"></span><span>Significant improvement:74%</span>
        </div>
        <div class="flex">
          <span class="cube" style="background: #36a2eb"></span><span>Helpfut: 23%</span>
        </div>
        <div class="flex">
          <span class="cube" style="background: #ffce56"></span><span>Not helpfut 3%</span>
        </div>
      </div>
      <div class="data-right">
        <div id="pieRight" class="pie"></div>
        <div class="flex">
          <span class="cube" style="background: #ff6082"></span><span>30 minutes or more:18%</span>
        </div>
        <div class="flex">
          <span class="cube" style="background: #36a2eb"></span><span>20 minutes or more:55%</span>
        </div>
        <div class="flex">
          <span class="cube" style="background: #ffce56"></span><span>10 minutes or more:25%</span>
        </div>
        <div class="flex">
          <span class="cube" style="background: #4bc0c0"></span><span>5 minutes or less:2%</span>
        </div>
      </div>
      <div class="text1 f-b animate__animated">{{$t('brandOverseas.caseData.title2')}}</div>
      <div class="text2 f-b animate__animated">{{$t('brandOverseas.caseData.title3')}}</div>
      <div class="text-left f-18 animate__animated">{{$t('brandOverseas.caseData.title4')}}</div>
      <div class="text-right f-18 animate__animated">{{$t('brandOverseas.caseData.title6')}}</div>
      <div class="bottom-text f-20">{{$t('brandOverseas.caseData.title5')}}</div>
    </div>
    <Footer></Footer>
  </div>

</template>
<script>
import Header from "@/components/header";
import Footer from "@/components/footer";
  export default {
    components: {Header, Footer },
    data() {
      return {
        option1: {
          series: [
            {
              type: 'pie',
              radius: ['40%', '90%'],
              avoidLabelOverlap: false,
              label: {
                show: false,
                position: 'center'
              },
              labelLine: {
                show: false
              },
              color: ['#ff6082', '#36a2eb', '#ffce56'],
              data: [
                {value: 74, name: '1'},
                {value: 23, name: '2'},
                {value: 3, name: '3'},
              ]
            }
          ],
          grid: { // 让图表占满容器
            top: "0",
            left: "0",
            right: "0",
            bottom: "0"
          }
        },
        option2: {
          series: [
            {
              type: 'pie',
              radius: ['40%', '90%'],
              avoidLabelOverlap: false,
              label: {
                show: false,
                position: 'center'
              },
              labelLine: {
                show: false
              },
              color: ['#ff6082', '#36a2eb', '#ffce56', '#4bc0c0'],
              data: [
                {value: 18, name: '1'},
                {value: 55, name: '2'},
                {value: 25, name: '3'},
                {value: 2, name: '4'},
              ]
            }
          ]
        }
      }
    },
    methods: {
      showCharts() {
        let myChart1 = this.$echarts.init(document.getElementById('pieLeft'));
        myChart1.setOption(this.option1)
        let myChart2 = this.$echarts.init(document.getElementById('pieRight'));
        myChart2.setOption(this.option2)
      }
    },
    mounted() {
      const io = new IntersectionObserver(entries => {
        entries.forEach(item => {
          if (item.isIntersecting) {
            if (item.target.classList[0] == 'whatsapp-left') {
              item.target.classList.add('animate__zoomIn')
            }
            if (item.target.classList[0] == 'img-wrapper') {
              item.target.classList.add('animate__zoomIn')
            }
            if (item.target.classList[0] == 'box1') {
              item.target.classList.add('animate__fadeInUp')
            }
            if (item.target.classList[0] == 'box2') {
              item.target.classList.add('animate__fadeInDown')
            }
            if (item.target.classList[0] == 'box3') {
              item.target.classList.add('animate__fadeInUp')
            }
            if (item.target.classList[0] == 'top-text') {
              item.target.classList.add('animate__zoomIn')
            }
            if (item.target.classList[0] == 'text1') {
              item.target.classList.add('animate__fadeInDown')
            }
            if (item.target.classList[0] == 'text2') {
              item.target.classList.add('animate__fadeInDown')
            }
            if (item.target.classList[0] == 'text-left') {
              item.target.classList.add('animate__fadeInUp')
            }
            if (item.target.classList[0] == 'text-right') {
              item.target.classList.add('animate__fadeInUp')
            }
            if (item.target.classList[0] == 'data-Left') {
              this.showCharts()
            }
          }
        })
      }, {})

      const nodeLists = [...document.querySelectorAll('.animate__animated')]
      nodeLists.forEach(box => {
        io.observe(box)
      })
    }
  }
</script>
<style lang="scss" scoped>
.header-wrapper {
  height: 632px;
}
.title-content {
  width: 100%;
  position: absolute;
  top: 185px;
  left: 0;
  right: 0;
  z-index: 11;
  .big-title {
    font-family: Microsoft YaHei;
    font-weight: bold;
    font-size: 67px;
    color: #FFFFFF;
    line-height: 67px;
  }
  .small-title {
    font-family: SourceHanSansCN;
    font-weight: 400;
    font-size: 40px;
    color: #FFFFFF;
    line-height: 40px;
    margin-top: 26px;
  }
}



.serve-wrapper {
  height: 957px;
  width: 100%;
  box-sizing: border-box;
  padding: 40px;
  background: #0455ec;
  .serve-content {
    width: 100%;
    height: 100%;
    background: #FFFFFF;
    display: flex;
    flex-direction: column;
    align-items: center;
    .top-content {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      color: #424242;
      .top-title {
        font-weight: bold;
        font-size: 48px;
        line-height: 48px;
        margin-top: 60px;
        margin-bottom: 35px;
      }
      .desc {
        font-weight: 400;
        font-size: 21px;
        line-height: 31px;
      }
    }
    .img-wrapper {
      width: 100%;
      padding: 0px 10%;
      box-sizing: border-box;
      display: flex;
      flex-wrap: wrap;
      .imgs {
        flex: 1 0 25%;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        position: relative;
        img {
          height: 240px;
          width: 240px;
          transition: transform 0.1s;
          &:hover {
            transform: scale(1.1);
            cursor: pointer;
          }
        }
        .tt {
          font-size: 20px;
          color: #424242;
        }
        .line {
          position: absolute;
          width: 2px;
          height: 90px;
          background: #c8dcf3;
          right: -1px;
          top: 30%
        }
      }
      .desc {
        margin-top: 45px;
        font-family: SourceHanSansCN;
        font-weight: 400;
        font-size: 32px;
        color: #73788B;
      }
    }
  }
}

.whatsapp-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 10%;
  box-sizing: border-box;
  .whatsapp-left {
    display: flex;
    flex-direction: column;
    flex: 1;
    color: black;
    text-align: start;
    color: #424242;
    margin-right: 124px;
    .text_1 {
      font-size: 72px;
      line-height: 72px;
    }
    .text_2 {
      font-weight: bold;
      font-size: 46px;
      line-height: 46px;
      margin-top: 60px;
      margin-bottom: 40px;
    }
    .text_3 {
      font-size: 20px;
      line-height: 30px;
    }
    .grid-wrap {
      width: 440px;
      display: flex;
      flex-wrap: wrap;
      margin-top: 30px;

      .item {
        flex: 1 0 50%;
        text-align: center;
        margin-bottom: 20px;
      }
    }
    .text_4 {
      height: 40px;
      box-sizing: border-box;
      padding: 0 60px;
      font-size: 20px;
      color: #FFFFFF;
      line-height: 40px;
      background: #25d366;
      border-radius: 15px;
      width: 70%;
      margin-top: 20px;
    }
  }
  .whatsapp-right {
    height: 100%;
    overflow: hidden;
    width: 640px;
    height: 950px;
    display: flex;
    justify-content: space-between;
    .box {
      display: flex;
      flex-direction: column;
      img {
        width: 196px;
        height: 372px;
      }
      img:nth-child(2) {
        margin-top: 30px;
        margin-bottom: 30px;
      }
    }
    .box:nth-child(1) {
      margin-top: -184px;
    }
    .box:nth-child(2) {
      margin-top: -56px;
    }
    .box:nth-child(3) {
      margin-top: -184px;
    }
  }
}

.data-wrappper {
  height: 958px;
  background: url("../assets/brandOverseas/bg2.png");
  background-size: 100% 100%;
  position: relative;
  color: #FFFFFF;
  overflow: hidden;
  .top-text {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    margin-top: 90px;
    span {
      display: inline-block;
      font-size: 48px;
      font-weight: bold;
      padding: 28px 80px;
      border-bottom: 2px solid #FFFFFF;
    }
  }
  .text1 {
    position: absolute;
    top: 260px;
    left: 300px;
    font-size: 24px;
  }
  .text2 {
    position: absolute;
    font-size: 24px;
    top: 260px;
    right: 680px;
  }
  .data-Left {
    position: absolute;
    top: 333px;
    left: 269px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    .flex {
      align-items: center;
      width: 100%;
      margin-bottom: 6px;
      text-align: start;
    }
  }
  .data-right {
    position: absolute;
    top: 245px;
    right: 330px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    .flex {
      width: 100%;
      align-items: center;
      margin-bottom: 6px;
      text-align: start;
    }
  }
  .text-left {
    position: absolute;
    top: 470px;
    left: 648px;
    width: 450px;
    line-height: 34px;
    text-align: start;
  }
  .text-right {
    position: absolute;
    line-height: 34px;
    top: 640px;
    left: 1300px;
    ext-align: start;
    width: 500px;
    text-align: start;
  }
  .bottom-text {
    position: absolute;
    bottom: 72px;
    left: 0;
    right: 0;
    text-align: center;
  }

  .cube{
    width: 42px;
    height: 14px;
    display: inline-block;
    margin-right: 6px;
  }

  #pieLeft {
    width: 302px;
    height: 302px;
  }
  #pieRight {
    width: 262px;
    height: 262px;
  }
}

.bg-img {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 0;
}
</style>
